import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
import { updateSelectedCalendarIds } from '../actions/publicActions';

export const updateSelectedCalendarIdsMutator = mutator(
    updateSelectedCalendarIds,
    actionMessage => {
        const { calendarIds } = actionMessage;
        getStore().calendarIds = calendarIds;
    }
);
